import { fmtPct } from "@/lib/api";

export function Change({ value, pct, className = "" }) {
  const positive = (value ?? pct ?? 0) >= 0;
  return (
    <span className={`mono ${positive ? "profit" : "loss"} ${className}`}>
      {pct != null ? fmtPct(pct) : (positive ? "+" : "") + Number(value).toFixed(2)}
    </span>
  );
}

export function Card({ children, className = "", ...props }) {
  return (
    <div className={`bg-zinc-900 border border-zinc-800 rounded-sm ${className}`} {...props}>
      {children}
    </div>
  );
}

export function CardHeader({ title, action, subtitle, tone = "default" }) {
  // Iter 49 — optional `tone` prop lets callers tint the whole header row.
  // Only "urgent" is defined for now (used on the Weekly Digest card when
  // the countdown flips to red). Extend as needed.
  const wrapperTone = tone === "urgent"
    ? "bg-red-950/20 border-red-500/40"
    : "border-zinc-800";
  const labelTone = tone === "urgent" ? "text-red-400" : "text-zinc-500";
  return (
    <div
      data-tone={tone}
      className={`flex items-start justify-between px-5 py-4 border-b transition-colors duration-500 ${wrapperTone}`}
    >
      <div>
        <div className={`mono text-[10px] uppercase tracking-widest ${labelTone}`}>{title}</div>
        {subtitle && <div className="text-sm text-zinc-300 mt-1">{subtitle}</div>}
      </div>
      {action}
    </div>
  );
}

export function Stat({ label, value, sub, tone = "default" }) {
  const toneClass = tone === "profit" ? "profit" : tone === "loss" ? "loss" : "text-white";
  return (
    <div className="p-5 bg-zinc-900 border border-zinc-800 rounded-sm">
      <div className="mono text-[10px] text-zinc-500 uppercase tracking-widest">{label}</div>
      <div className={`mono text-3xl font-bold mt-2 ${toneClass}`}>{value}</div>
      {sub && <div className="mono text-xs text-zinc-500 mt-2">{sub}</div>}
    </div>
  );
}
